import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useUserHaveCompany = () => {
  const { locale } = useLocale();
  const queryClient = useQueryClient();

  const { mutate: checkIsUserHasCompany } = useAppMutation([QueryKey.IS_USER_HAVE_COMPANY], {
    mutationFn: () =>
      ApiService.get<string>(
        { endpoint: BackendRoute.COMPANIES, routePath: ['is-user-have-company'] },
        { locale },
      ),
  });

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.IS_USER_HAVE_COMPANY] });
  };

  return {
    checkIsUserHasCompany,
    invalidateQuery,
  };
};
